





















import {
  DynamicDocumentItem,
  InstallationModuleData,
  ListItem,
  MechanicInstallation,
  PanelOrientation
} from "@/types";

import Vue, { PropType } from "vue";

export default Vue.extend({
  props: {
    item: Object as PropType<DynamicDocumentItem>,
    moduleData: Object as PropType<InstallationModuleData>,
    installation: { type: Object as PropType<MechanicInstallation> }
  },

  mounted() {
    if (!this.moduleData.panelOrientation) {
      this.moduleData.panelOrientation = this.installation.screening.panelOrientation;
      this.$emit("save:module");
    }
  },

  computed: {
    orientations(): ListItem<PanelOrientation>[] {
      return [
        { value: "landscape", text: "Landscape" },
        { value: "portrait", text: "Portrait" }
      ];
    }
  }
});
